.wrap {
  width: 100%;
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: var(--vc-text-md);

  th {
    position: sticky;
    top: 0;
    z-index: 1;
    padding: 10px 14px;
    text-align: left;
    font-size: var(--vc-text-xs);
    font-weight: var(--vc-weight-semibold);
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--vc-text-muted);
    background: var(--vc-surface-muted);
    border-bottom: 1px solid var(--vc-border);
    white-space: nowrap;
  }

  td {
    padding: 12px 14px;
    border-bottom: 1px solid var(--vc-border);
    vertical-align: middle;
    color: var(--vc-text);
  }

  tbody tr:last-child td {
    border-bottom: 0;
  }

  &.hover tbody tr:hover td {
    background: var(--vc-surface-muted);
  }

  &.clickable tbody tr {
    cursor: pointer;
  }

  &.compact td {
    padding: 8px 12px;
  }

  .right {
    text-align: right !important;
  }

  .center {
    text-align: center !important;
  }

  .nowrap {
    white-space: nowrap;
  }

  .sortable {
    cursor: pointer;
    user-select: none;

    &:hover {
      color: var(--vc-text);
    }
  }

  .sortIcon {
    display: inline-block;
    margin-left: 4px;
    vertical-align: middle;
    opacity: 0.6;
  }

  .stateCell {
    padding: 0 !important;
  }
}

.muted {
  color: var(--vc-text-muted);
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-top: 1px solid var(--vc-border);
  font-size: var(--vc-text-sm);
  color: var(--vc-text-muted);
  flex-wrap: wrap;

  .pages {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .pageBtn {
    min-width: 30px;
    height: 30px;
    padding: 0 8px;
    border-radius: var(--vc-radius-sm);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: var(--vc-text-sm);
    font-weight: var(--vc-weight-medium);
    color: var(--vc-text-secondary);
    border: 1px solid transparent;

    &:hover:not(:disabled) {
      background: var(--vc-gray-soft);
      color: var(--vc-text);
    }

    &:disabled {
      opacity: 0.4;
    }

    &.pageActive {
      background: var(--vc-text);
      color: #fff;

      &:hover:not(:disabled) {
        background: var(--vc-text);
        color: #fff;
      }
    }
  }

  .ellipsis {
    padding: 0 4px;
  }
}
